import styled from 'styled-components'
import { StyledButton } from 'Components/Buttons/StyledButton'
import { FileType, FileUpload } from 'Components/Inputs/FileUpload'
import { AlertBanner } from 'Components/AlertBanner/AlertBanner'
import { spacingMD } from 'Utils/styles/spacing'
import { elfGreen, elfGreenFaded, mineralGreen } from 'Utils/styles/colors'
import { AppIconMap, AppIcons } from 'Utils/types/appIcons'

const Description = styled.p`
  color: ${mineralGreen};
  margin-bottom: ${spacingMD};
`

const Section = styled.div`
  margin-bottom: ${spacingMD};
`

const FullWidthButtonWrapper = styled.div`
  width: 100%;

  button {
    width: 100%;
  }
`

type UploadViewProps = {
  onDownloadTemplate: () => Promise<void>
  onFileChange: (file: File | null) => void
  isDownloading: boolean
}

export const UploadView = ({
  onDownloadTemplate,
  onFileChange,
  isDownloading
}: UploadViewProps) => {
  return (
    <>
      <Description>
        Use this tool to create new users, update existing users, or remove users via CSV upload.
        Download the template with current user data, make your changes, and upload to preview
        before confirming.
      </Description>

      <AlertBanner
        alert="CSV Format: The template includes all user fields, program memberships, and metadata. Email addresses cannot be changed and are used to match existing users."
        style={{
          padding: 10,
          marginBottom: spacingMD,
          border: `1px solid ${elfGreen}`,
          backgroundColor: elfGreenFaded,
          width: 'calc(100% - 22px)'
        }}
        iconSrc={AppIconMap[AppIcons.InfoCircle]}
      />

      <Section>
        <FullWidthButtonWrapper>
          <StyledButton
            secondary
            onClick={onDownloadTemplate}
            disabled={isDownloading}
            isLoading={isDownloading}
            id="users.bulkUserManagement.downloadTemplate"
          />
        </FullWidthButtonWrapper>
      </Section>

      <Description>
        After editing, upload your CSV file to preview all changes before confirming. The preview
        will show new users to be created, existing users to be updated, and users to be removed.
      </Description>

      <FileUpload setFileValue={onFileChange} fileType={FileType.Csv} />
    </>
  )
}
